app.filter("nutritional", function($sce, odmRecommendService) {
	return function (msgdata) {
		var htmlstr = "";
		var dmEnables = odmRecommendService.getMsgEnables();
		if( msgdata != null ) {
			var enablecnt = 0;
			for( var i = 0; i < msgdata.length; i++ ) {
                if( dmEnables[msgdata[i].category] && msgdata[i].message != "NA" ) {
					htmlstr += msgdata[i].message + "<br/>";
					enablecnt++;
				}
            };
			if( enablecnt == 0 ) {
				htmlstr = "特に管理栄養士からのアドバイスはありません。";
			}
		}
		return $sce.trustAsHtml( htmlstr );
	};
});